import CustomerFooter from "./CustomerFooter";
import "../ReportTable.css";
import HeaderCustomer from "./HeaderCustomer";
import './Customer.css';
import { useEffect, useRef } from "react";
import axios from "axios";
import { useState } from "react";
import { Table } from "react-bootstrap";
import { addDays } from 'date-fns';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import ApiHandler from "../../ApiHandler";
import { DatePicker } from "antd";
import dayjs from "dayjs";
import LoaderTri from "../Loader/LoaderTri";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from "@fortawesome/free-solid-svg-icons";
import { toast } from "react-toastify";
import FirmSelect from './FirmSelect';
import { getReportFirmId, getReportFirmLocalUrl } from '../../ClientSelection';
import { dateField } from "../../dateOnly";

const initialValues = {
    from: dayjs(),
    to: dayjs()
};
export default function DownloadInvoice() {
    const [dates, setDates] = useState(initialValues);

    const [showInvoiceData, SetShowInvoiceData] = useState([]);
    const [startDate, setStartDate] = useState(new Date());
    const [endDate, setEndDate] = useState(new Date());
    const [alldatesData, setAlldatesData] = useState([])
    const [openDate, setOpenDate] = useState(false)
    const [isLoading, setIsLoading] = useState(false);
    const [viewdata, setViewdata] = useState(false)
    // The firm whose server these bills come from. Held explicitly so the
    // request cannot silently fall back to the login firm's cached LocalURL.
    const [firm, setFirm] = useState(null)
    const [range, setRange] = useState([{
        startdate: new Date(),
        endDate: addDays(new Date(), ''),
        key: 'selection'
    }])


    const refOne = useRef(null);

    useEffect(() => {
        document.addEventListener("keydown", hideOnEscape, true)
        document.addEventListener("click", hideOnClickOutside, true)
        return () => {
            document.removeEventListener("keydown", hideOnEscape, true)
            document.removeEventListener("click", hideOnClickOutside, true)
        }
    }, []);

    const hideOnEscape = (e) => {
        console.log(e.key)
        if (e.key === "Escape") {
            setOpenDate(false)
        }
    }


    const hideOnClickOutside = (e) => {
        if (refOne.current && !refOne.current.contains(e.target)) {
            setOpenDate(false)
        }
    }

    const handleSelects = (date) => {

        let filtered = alldatesData.filter((product) => {

            let productDate = new Date(product["date"]);
            return (
                productDate >= date.selection.startDate &&
                productDate <= date.selection.endDate

            );
        });
        setStartDate(date.selection.startDate);
        setEndDate(date.selection.endDate);
        SetShowInvoiceData(filtered);
        console.log(date.selection.startDate)
        console.log(date.selection.endDate)
    };

    const selectionRange = {
        startDate: startDate,
        endDate: endDate,
        key: "selection",
    };

    // NOTE: this is wired straight to onClick, so the first argument may be a
    // click event. Only accept a string url.
    function toGetData(overrideUrl) {
        const explicitUrl = typeof overrideUrl === "string" ? overrideUrl : null
        const localUrl = explicitUrl || (firm && firm.localUrl) || getReportFirmLocalUrl()
        const clientId = (firm && firm.wClientId) || getReportFirmId()
        if (!localUrl) {
            toast.error("No server configured for the selected firm")
            return
        }
        console.log("GeCustomerBillList ->", localUrl, "firm:", firm && firm.firmName)
        const user = JSON.parse(localStorage.getItem('user-info'))
        setViewdata(true)
        setIsLoading(true)
        ApiHandler.post({
            url: localUrl + "api/OwnApp/GeCustomerBillList",
            data: {
                startdate: dayjs(dates.from).format("YYYYMMDD"),
                enddate: dayjs(dates.to).format("YYYYMMDD"),
                // startdate: moment(selectionRange.startDate).format("YYYYMMDD"),
                // enddate: moment(selectionRange.endDate).format("YYYYMMDD"),
                code: user.code,
                // the firm from the dropdown, as its own field
                wClientId: clientId,


            }, useUserUrl: true
        })
            .then(((result) => {
                console.log(result);
                console.log(result.data);
                setAlldatesData(result.data)
                SetShowInvoiceData(result.data)

            }))
            .catch(err => {
                console.error(err);
                if (err.response && err.response.status && err.response.status === 401) {
                    console.log(err.response);
                    //   RefreshTokenHandler();
                    //  ToastError("Token has expired Please refresh");
                }
            })

            .finally(() => {
                setIsLoading(false)
            })




    }

    // setCsvFile(localUrl + "/bills/" + 15201 + "_" + elm.billNo + "_" + elm.date.split('/') + ".csv")
    //setCsvFile(localUrl + "bills/" + 15201 + "_" + elm.billNo + "_" + elm.date.replaceAll('/', '', 'yyyymmdd') + ".csv")
    // console.log(localUrl + "bills/" + 15201 + "_" + elm.billno + "_" + elm.date.replaceAll('/', '') + ".csv")
    const [isDownloading, setIsDownloading] = useState(false)
    function getURLCSV(elm, type) {
        setIsDownloading(true);
        const user = JSON.parse(localStorage.getItem('user-info'))
        const localUrl = (firm && firm.localUrl) || getReportFirmLocalUrl()
        const clientId = (firm && firm.wClientId) || getReportFirmId()
        ApiHandler.post({
            url: localUrl + "api/OwnApp/CustomerInvoiceDownload",
            data: {
                type: elm._type,
                billno: elm.billNo,
                date: stringConvert(elm),
                custCode: (user.code + "").toString(),
                // the firm from the dropdown, as its own field
                wClientId: clientId,
                fileType: type
                // pdf "xls"
            },
            useUserUrl: true
        }
        )
            .then(((result) => {
                console.log(result);
                window.location.href = localUrl + "bills/" + user.code + "_" + elm.billNo + "_" + stringConvert(elm) + "." + type;

            }))
            .catch(err => {
                console.error(err);
                if (err.response && err.response.status && err.response.status === 401) {
                    console.log(err.response);
                    //   RefreshTokenHandler();
                    //  ToastError("Token has expired Please refresh");
                }
                toast.error("Failed To Download ", type);
            })
            .finally(() => {
                setIsDownloading(false);
            })


    }



    const stringConvert = (elm) => {
        console.log(elm);
        let string = elm.date + "";
        string = string.replaceAll("/", "");
        console.log(string.substring(4, 8) + string.substring(2, 4) + string.substring(0, 2));
        return string.substring(4, 8) + string.substring(2, 4) + string.substring(0, 2);
    }


    // Record the firm, then refetch for it. `firm` state has not updated yet at
    // this point, so the new url is passed straight through to toGetData.
    const handleFirmChange = (picked) => {
        setFirm(picked || null);
        SetShowInvoiceData([]);
        setAlldatesData([]);
        const url = picked && picked.localUrl;
        if (viewdata && url) {
            toGetData(url);
        }
    };


    return (
        <div className="custShell">
            <HeaderCustomer />
            <div className="custMain">
                <div className="row m-0">
                    <div className="col-lg-10 offset-lg-1"   >
                        <h5 style={{
                            marginTop: "20px",
                            fontFamily: "sans-serif",
                            // fontSize: "17px",

                        }}>Select details to view Invoice</h5>
                    </div>
                    <div className="col-lg-10 offset-lg-1">
                        <div className="row  ">
                            <div className="col-lg-3  ">
                                <FirmSelect
                                    onReady={(picked) => setFirm(picked || null)}
                                    onChange={handleFirmChange}
                                />
                            </div>
                            <div className="col-lg-3  "   >
                                <DatePicker.RangePicker
                                    format={"DD-MM-YYYY"}
                                    size="middle"
                                    className="mb-2"
                                    value={[dates.from, dates.to]}
                                    onChange={(e) => {
                                        console.log(e);

                                        if (e) {
                                            setDates({
                                                from: e[0],
                                                to: e[1],
                                            });
                                        } else {
                                            setDates({ from: null, to: null });
                                        }
                                    }}
                                />
                            </div>
                            <div className="col-lg-4  "   >
                                <button
                                    type="button"
                                    className="btn mb-3 btn-primary btn-sm"
                                    onClick={() => toGetData()}

                                >View</button>
                            </div>
                            <div className="col-lg-5 text-center "   >
                                {isDownloading &&
                                    <div style={{ position: "relative" }}>
                                        <div className="d-flex
                                        align-items-center 
                                        " style={{
                                                // position: "absolute",
                                            }}>
                                            <FontAwesomeIcon className="mr-2" icon={faDownload} />


                                            Downloading...!
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>


                    {
                        viewdata &&
                        <div className="row m-0">
                            <div className=" p-0 col-lg-10 offset-lg-1">
                                <h6>Invoice List</h6>
                                <div className="rptScroll">
                                    <Table striped className="rptTable">
                                        <thead className="threAd">
                                            <tr className="threAd_tr">
                                                <th >Invoice Date</th>
                                                <th style={{ textAlign: "end" }}>Invoice Number</th>
                                                <th style={{ textAlign: "center" }}>Download</th>


                                            </tr>
                                        </thead>


                                        {


                                            showInvoiceData.map((elm, index) => {
                                                return <tbody className="tboDY" key={index} >
                                                    <tr

                                                    >

                                                        <td >{dateField(elm, 'date', 'billDate', 'invoiceDate')}</td>
                                                        <td style={{ textAlign: "end" }}>{elm.billNo}</td>
                                                        {/* one invoice, three file types - each button is
                                                            coloured and labelled for the file it downloads */}
                                                        <td className="BTNs">
                                                            <button
                                                                type="button"
                                                                className="invBtn csvBTN"
                                                                title={"Download invoice " + elm.billNo + " as a CSV data file"}
                                                                onClick={() => { getURLCSV(elm, "csv") }}
                                                            >
                                                                <span className="invBtnExt">.csv</span>
                                                                <span className="invBtnName">Data</span>
                                                            </button>

                                                            <button
                                                                type="button"
                                                                className="invBtn pdfBTN"
                                                                title={"Download invoice " + elm.billNo + " as a PDF to print or e-mail"}
                                                                onClick={() => { getURLCSV(elm, "pdf") }}
                                                            >
                                                                <span className="invBtnExt">.pdf</span>
                                                                <span className="invBtnName">Print</span>
                                                            </button>

                                                            <button
                                                                type="button"
                                                                className="invBtn exclBTN"
                                                                title={"Download invoice " + elm.billNo + " as an Excel spreadsheet"}
                                                                onClick={() => { getURLCSV(elm, "xlsx") }}
                                                            >
                                                                <span className="invBtnExt">.xlsx</span>
                                                                <span className="invBtnName">Excel</span>
                                                            </button>
                                                        </td>

                                                    </tr>


                                                </tbody>



                                            })

                                        }

                                    </Table >

                                </div>
                                {isLoading &&
                                    <div className="d-flex justify-content-center" >

                                        <LoaderTri />

                                    </div>


                                }
                            </div>
                        </div>
                    }
                </div>
            </div>
            <CustomerFooter />
        </div>
    )
}